import React from "react";
import { CheckCircle2, Layers3, Settings2 } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageProvider";
import RevealOnScroll from "../RevealOnScroll";

const steps = [
  {
    icon: Layers3,
    title: "Choisissez votre solution",
    text: "Sélectionnez l’API WonyaPay, BulkPay, l’application mobile ou une solution développée sur mesure.",
  },
  {
    icon: Settings2,
    title: "Intégrez ou configurez",
    text: "Notre équipe vous accompagne dans la configuration, les tests et la mise en service.",
  },
  {
    icon: CheckCircle2,
    title: "Payez, encaissez et suivez",
    text: "Gérez vos opérations depuis une interface claire, sécurisée et adaptée à votre activité.",
  },
];

const HomeHowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section
      className="ws-section ws-home-process-section"
      aria-labelledby="ws-home-process-title"
    >
      <div className="ws-shell">
        <RevealOnScroll className="ws-section-heading ws-section-heading--center">
          <span className="ws-kicker">{t("Un parcours simple")}</span>
          <h2 id="ws-home-process-title">
            {t("Comment fonctionne l’écosystème WonyaSoft ?")}
          </h2>
          <p>
            {t(
              "Trois étapes structurées pour passer du besoin à des opérations suivies au quotidien.",
            )}
          </p>
        </RevealOnScroll>

        <ol className="ws-home-process">
          {steps.map(({ icon: Icon, title, text }, index) => (
            <RevealOnScroll
              as="li"
              className="ws-home-process__step"
              delay={index * 110}
              key={title}
            >
              <span className="ws-home-process__number">0{index + 1}</span>
              <span className="ws-home-process__icon">
                <Icon size={23} aria-hidden="true" />
              </span>
              <h3>{t(title)}</h3>
              <p>{t(text)}</p>
            </RevealOnScroll>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HomeHowItWorks;
